module.exports = __webpack_public_path__ + "static/media/rates-logo.d49d29e1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rates-logo.svg
// module id = 1614
// module chunks = 0